import { Navigate, useLocation } from "react-router-dom";
import { useSession } from "~/shared/lib/auth/auth-provider";

const PUBLIC_PATHS = new Set([
    "/",
    "/video",
    "/images",
    "/pro",
    "/deal",
    "/start",
    "/economy",
    "/privacy",
    "/oferta",
    "/login",
    "/auth/cleanup",
    "/auth/verify",
    "/invitation",
    "/project-invite",
    "/rocket-omni-test",
]);

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const { status } = useSession();
    const location = useLocation();

    if (PUBLIC_PATHS.has(location.pathname)) return <>{children}</>;
    if (status === "loading") {
        return (
            <div className="flex h-screen items-center justify-center">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-muted border-t-foreground" />
            </div>
        );
    }
    if (status === "unauthenticated") return <Navigate to="/auth/cleanup" replace />;
    return <>{children}</>;
}
